<val-boite-dialogue-generique #boiteDialogue
                              [titre]="cleTitre | transloco"
                              class="val-activer-desactiver-pieces-vente"
                              [validerDesactive]="actionSelectionnee === null"
                              (validerClick)="Valider ()"
                              (annulerClick)="Annuler ()">
  <div contenu class="val-activer-desactiver-pieces-vente-contenu">
    <val-simple-panel>
      <val-controle-conteneur [label]="'vente.activer-desactiver.action' | transloco"
                              [tailleLabel]="tailleLabels">
        <kendo-combobox class="val-kd-combobox"
                        size="small"
                        [clearButton]="false"
                        [popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
                        [data]="actions"
                        textField="libelle"
                        valueField="desactiver"
                        [(value)]="actionSelectionnee">
        </kendo-combobox>
      </val-controle-conteneur>
      <div style="height: 4px;"></div>
      <div class="val-activer-desactiver-pieces-vente-selection">
        {{'vente.activer-desactiver.pieces-selectionnees' | transloco: {nb: nombrePiecesSelectionnees} }}
      </div>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
